import { useMemo } from 'react';
import ForgotPasswordPage from 'Components/auth/ForgotPassword';
import LoginPage from 'Components/auth/Login';
import CaregiverConnection from 'Components/connection/Caregiver/CaregiverConnection';
import CaregiverInvitation from 'Components/connection/Caregiver/CaregiverInvitation';
import InviteCaregiver from 'Components/connection/Caregiver/InviteCaregiver';
import LibreDataShareConnection from 'Components/connection/LibreDataShare/LibreDataShareConnection';
import MainConnection from 'Components/connection/MainConnection';
import CommercialApiAddConnection from 'Components/connection/Partner/CommercialApi/AddPartnerConnection';
import CommercialApiConfirmConnection from 'Components/connection/Partner/CommercialApi/ConfirmPartnerConnection';
import PartnerConnection from 'Components/connection/Partner/PartnerConnection';
import AddPractice from 'Components/connection/Practice/AddPractice';
import PracticeConnection from 'Components/connection/Practice/PracticeConnection';
import PracticeInvitation from 'Components/connection/Practice/PracticeInvitation';
import InitializationErrorPage from 'Components/utility/InitializationErrorPage';
const routes = [
    { route: 'login', component: LoginPage },
    { route: 'forgot-password', component: ForgotPasswordPage },
    { route: 'connections', component: MainConnection },
    { route: 'llu-pending-connection', component: CaregiverInvitation },
    { route: 'llu-connection', component: CaregiverConnection },
    { route: 'llu-add-connection', component: InviteCaregiver },
    { route: 'partner-add-connection', component: CommercialApiAddConnection },
    { route: 'partner-confirm-connection', component: CommercialApiConfirmConnection },
    { route: 'lv-practice-connection', component: PracticeConnection },
    { route: 'lv-practice-invitation', component: PracticeInvitation },
    { route: 'lds-connection', component: LibreDataShareConnection },
    { route: 'lv-add-practice', component: AddPractice },
    { route: 'partner-connection', component: PartnerConnection },
];
const useRouter = (location, queryString, initErrorStatus, data) => {
    const { Component, props } = useMemo(() => {
        if (initErrorStatus) {
            return {
                Component: InitializationErrorPage,
                props: { errorStatus: initErrorStatus, navigationQueryString: queryString },
            };
        }
        const lowerCaseLocation = location.toLowerCase();
        const route = routes.find((r) => lowerCaseLocation.startsWith(`/${r.route.toLowerCase()}`));
        if (route) {
            return { Component: route.component, props: { ...route.props, data } };
        }
        return { Component: LoginPage };
    }, [data, initErrorStatus, location, queryString]);
    return { Component, props };
};
export default useRouter;
